import React, { useState } from 'react';

function LifestyleCard({ lifestyle, isAdmin = false, onEdit, onDelete }) {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <article className={isAdmin
      ? "group overflow-hidden rounded-2xl border border-gray-800 bg-gray-900/60 backdrop-blur-sm transition-all duration-500 hover:scale-[1.02] hover:border-red-500/50 hover:shadow-[0_0_40px_rgba(239,68,68,0.15)]"
      : "group flex min-w-0 flex-col overflow-hidden rounded-xl border border-line bg-surface-850 transition-all duration-200 hover:-translate-y-0.5 hover:border-line-strong hover:bg-surface-800"}
    >
      <div className={`relative overflow-hidden bg-surface-900 ${isAdmin ? "h-72" : "h-64 sm:h-72"}`}>
        {lifestyle.profileImageUrl && !imageFailed ? (
          <img
            src={lifestyle.profileImageUrl}
            alt={`${lifestyle.name || "Lifestyle profile"}`}
            loading="lazy"
            onError={() => setImageFailed(true)}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.025]"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center" role="img" aria-label="Profile image unavailable">
            <span className="flex h-20 w-20 items-center justify-center rounded-2xl border border-line bg-surface-850">
              <svg aria-hidden="true" className="h-9 w-9 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.1a8.25 8.25 0 0115 0A17.9 17.9 0 0112 21.75c-2.73 0-5.31-.61-7.5-1.65z" />
              </svg>
            </span>
          </div>
        )}
        <div aria-hidden="true" className={isAdmin ? "absolute inset-0 bg-black/60" : "absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-black/80 to-transparent"} />
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className={isAdmin ? "mb-2 text-2xl font-bold text-white" : "mb-2 break-words text-xl font-semibold tracking-tight text-white sm:text-2xl"}>{lifestyle.name || "Name unavailable"}</h3>
          <div className="flex flex-wrap items-center gap-2">
            {lifestyle.age !== undefined && lifestyle.age !== null && lifestyle.age !== "" && (
              <span className={isAdmin ? "rounded-full border border-red-500/30 bg-red-600/20 px-3 py-1 text-xs text-red-300" : "rounded-md border border-accent/25 bg-accent/15 px-2.5 py-1 text-xs font-medium text-accent-soft"}>
                {isAdmin ? `AGE: ${lifestyle.age}` : `Age ${lifestyle.age}`}
              </span>
            )}
            {isAdmin && lifestyle.height && (
              <span className={isAdmin ? "rounded-full border border-gray-700 bg-gray-800/50 px-3 py-1 text-xs text-gray-300" : "rounded-md border border-line bg-surface-850/90 px-2.5 py-1 text-xs font-medium text-gray-300"}>
                {isAdmin ? `HEIGHT: ${lifestyle.height}` : `Height ${lifestyle.height}`}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className={isAdmin ? "p-6" : "flex flex-1 flex-col p-5 sm:p-6"}>
        <p className={isAdmin ? "mb-4 line-clamp-3 text-sm leading-relaxed text-gray-300" : "mb-4 min-h-[3rem] text-sm leading-6 text-gray-400 line-clamp-3"}>
          {lifestyle.description || "Explore this profile for more information."}
        </p>
        
        {isAdmin && (
          <div className={isAdmin ? "flex gap-3 border-t border-gray-800 pt-4" : "flex gap-3 border-t border-line pt-4"}>
            <button
              onClick={() => onEdit(lifestyle)}
              className={isAdmin ? "flex flex-1 items-center justify-center gap-2 rounded-xl border border-gray-700 bg-gray-800/50 px-4 py-2.5 text-white transition-all duration-300 hover:border-gray-600 hover:bg-gray-700/50" : "btn-secondary min-h-11 flex-1 gap-2"}
            >
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Edit
            </button>
            <button
              onClick={() => onDelete(lifestyle)}
              className={isAdmin ? "flex items-center justify-center gap-2 rounded-xl border border-red-500/20 bg-red-600/10 px-4 py-2.5 text-red-400 transition-all duration-300 hover:border-red-500/50 hover:bg-red-600/30 hover:text-white" : "btn-danger min-h-11 gap-2"}
            >
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          </div>
        )}
      </div>
    </article>
  );
}

export default LifestyleCard;